module.exports = {"pathContext":{"name":"LocationIntegrations","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"location","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"Location","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"message","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":"Result of updating a location's integrations settings","enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-location-integrations.json
// module id = 1843
// module chunks = 53224078107011